import { useLogisticaConfiguration, withLogisticaConfiguration } from "../../../logistica/configurazione/LogisticaConfigurationProvider";
import React, { useEffect, useState } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import InputDatoProdotto from "../../../modificaProdotti/elementiPagina/InputDatoProdotto";
import _ from "lodash";
import apiUrl from "../../../Apiurl";
import InputDatoTendinaGenerico from "../../../modificaProdotti/elementiPagina/InputDatoTendinaGenerico";
import InputTendinaDatoProdotto from "../../../modificaProdotti/elementiPagina/InputTendinaDatoProdotto";
import RiquadrinoContatto from "../../../logistica/AreaOrdiniComponenti/OrdineComponenti/RiquadrinoContatto";
import ListaAssocia from "../../componenti/ListaAssocia";
import RiquadrinoBrand from "../../../logistica/AreaOrdiniComponenti/OrdineComponenti/RiquadrinoBrand";
import TastoSelezionaTab from "../../../logistica/AreaOrdiniComponenti/OrdineComponenti/TastoSelezionaTab";

function ModificaFornitori({
    elemento,
    setElemento,
    utente,
    mobile
}) {
  const configuration = useLogisticaConfiguration();
  const datiTendineOrdine = { ...configuration.datiTendineOrdine };



    const {
        buttonClassesWhite,
        buttonClassesRed,
        buttonClassesGreen,
        classiTastoSblocco,
        vociMenuTabs,
        vociMenuTabsSelezionata,
        inputClassesNOW,
        riquadroClassesRed
    } = stilePulsanti

    let classDivPrincipale = "fixed-l w-100-l sfondoColChiaro h-100 colonnaTuttaPagina-ns flex justify-center"


    ///// HOOKS //////////////////

    const [elementoTemp, setElementoTemp] = useState(elemento);
    const [salvato, setSalvato] = useState(true);
    const [tab, setTab] = useState("brandEcontatti");
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    const [alert, setAlert] = useState("");
    const [resultSalvataggio, setResultSalvataggio] = useState(false);
    const [alertSalvataggio, setAlertSalvataggio] = useState(false);
    const [datiStati, setDatiStati] = useState([]);

    datiTendineOrdine.dhlCodPaese = datiStati.map((stato) => {
        return { idPS: stato["iso_code"], desc: stato["namePS"] + " - " + stato["iso_code"] }
    })

    datiTendineOrdine.nomiNazioni = datiStati.map((stato) => {
        return { idPS: stato["namePS"], desc: stato["namePS"] }
    })

    datiTendineOrdine.codiceNazioni = datiStati.map((stato) => {
        return { idPS: stato["codPaeseAccess"], desc: stato["namePS"] + " - " + stato["codPaeseAccess"] }
    })

    datiTendineOrdine.prefissoNazione = datiStati.map((stato) => {
        return { idPS: stato["call_prefix"], desc: stato["namePS"] + " - " + stato["call_prefix"] }
    })

    useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetch(apiUrl + "/logistica/ordine/getTabStati", { headers: { Authorization: "Bearer " + token } })
            .then(resp => resp.json())
            .then(data => setDatiStati(data))
    }, [token]);


    ///// FUNZIONI ///////////////

    useEffect(() => {
        const getUserMetadata = async () => {
            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };
        getUserMetadata();
    }, [getAccessTokenSilently, user?.sub]);

    const handleChange = async function (evt) {
        setSalvato(false);
        const value = evt.target.value;
        try {
            if (evt.target.name.includes(".") || evt.target.name.includes("[")) {
                const update = _.set(_.cloneDeep(elementoTemp), evt.target.name, value) // METODO RESOURCE EXPENSIVE
                setElementoTemp(update)
            } else if (!evt.target.name.includes(".") && !evt.target.name.includes("[")) {
                setElementoTemp({
                    ...elementoTemp,
                    [evt.target.name]: value
                });
            } else {
                setAlert("Errore cambio dato")
            }
        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato nestato: " + err)
            throw err;
        }
    }

    function togliMailto(string) {
        return string.substring(0, string.indexOf('#'));
    }

    function cambiaTab(e) {
        e.preventDefault();
        setTab(e.target.id);
    }

    async function salvaProdotto(e) {
        e.preventDefault();
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        try {
            const data = {
                fornitore: elementoTemp
                /* utente: utente.username,
                permessi: utente.permessiAPI */
            }
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                }
            }
            axios.patch(apiUrl + "/anagrafiche/salvaFornitore", data, config)
                .then((resp) => {
                    if (resp.data.errno) {
                        setAlertSalvataggio(`Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`)
                    } else {
                        setAlertSalvataggio(false)
                        setResultSalvataggio(resp.data)
                        setSalvato(true);
                        setElemento(false);
                    }
                })
        } catch (err) {
            console.log("Errore nell'invio del prodotto alle API': " + err)
            throw err;
        }
    }

    async function salvaProdottoSenzaChiudere(e) {
        e.preventDefault();
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        try {
            const data = {
                fornitore: elementoTemp
                /* utente: utente.username,
                permessi: utente.permessiAPI */
            }
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                }
            }
            axios.patch(apiUrl + "/anagrafiche/salvaFornitore", data, config)
                .then((resp) => {
                    if (resp.data.errno) {
                        setAlertSalvataggio(`Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`)
                    } else {
                        setElementoTemp({
                            ...elementoTemp,
                            id: resp.data.insertId
                        });
                        setAlertSalvataggio(false)
                        setResultSalvataggio(resp.data)
                        setSalvato(true);
                    }
                })
        } catch (err) {
            console.log("Errore nell'invio del prodotto alle API': " + err)
            throw err;
        }
    }

    function chiudiSenzaSalvare(e) {
        e.preventDefault()
        setElemento(false)
    }

    //////////// RIQUADRINI DA PASSARE A LISTE ASSOCIAZIONI

    function listaRiquadriContatti(el, funzioneRimuovi) {
        return (<RiquadrinoContatto
            elemento={el}
            rimuoviAssociazione={funzioneRimuovi}
            /* funzioneScegliID={funzioneScegliID} */
            scelto={true}
        />)
    }

    function listaRiquadriBrands(el, funzioneRimuovi) {
        return (<RiquadrinoBrand
            elemento={el}
            rimuoviAssociazione={funzioneRimuovi}
            /* funzioneScegliID={funzioneScegliID} */
            scelto={true}
        />)
    }

    /////////////////////////////////////////// COLONNE /////////////////////////////////////

    function riquadroSalvataggio() {
        return (
            <div>
                {alertSalvataggio && <div className={riquadroClassesRed + " mb2"}>{alertSalvataggio}</div>}
                {!salvato && <button className={buttonClassesGreen + " mb2"} onClick={salvaProdottoSenzaChiudere}>Salva</button>}
                {!salvato && <button className={buttonClassesGreen + " mb2"} onClick={salvaProdotto}>Salva e chiudi</button>}                
                {!salvato && <button className={buttonClassesRed + " mb2"} onClick={chiudiSenzaSalvare}>Chiudi senza salvare</button>}
                {salvato && <button className={buttonClassesGreen + " mb2"} onClick={chiudiSenzaSalvare}>Chiudi</button>}
                {alert && <h3 className="tastoRosso white">{alert}</h3>}
            </div>
        )
    }

    const linkWrite = <div><a href={elementoTemp["linkFolderWrite"]} target="_blank" rel="noopener noreferrer" className={stilePulsanti.buttonClassesWhite + " flex items-center justify-center"}><span className='material-icons f3 mr2'>folder</span> CARTELLA ONEDRIVE</a></div>
    const linkRead = <div><a href={elementoTemp["linkFolderRead"]} target="_blank" rel="noopener noreferrer" className={stilePulsanti.buttonClassesWhite + " flex items-center justify-center"}><span className='material-icons f3 mr2'>folder</span> CARTELLA ONEDRIVE</a></div>


    function riquadroDatiFornitore() {
        return (
            <div className="">
                <h2>{elementoTemp.nome}</h2>
                {(utente.permessiAPI["update:database"] && elementoTemp["linkFolderWrite"]) && linkWrite}
                {((utente.permessiAPI["read:database"] && elementoTemp["linkFolderRead"]) || (utente.permessiAPI["update:database"] && elementoTemp["linkFolderRead"])) && linkRead}

                {/* <h2>{elementoTemp.nomeFornitore}</h2> */}
                <div className="mt3 mb3 flex flex-wrap">
                    <InputDatoProdotto
                        inputLabel="nome"
                        datoName='nome'
                        datoId="nome"
                        datoValue={elementoTemp.nome ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="telefono"
                        datoName='telefono'
                        datoId="telefono"
                        datoValue={elementoTemp.telefono ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                </div>
                <label for="note" className="w-100 mt3">Note</label>
                {utente.permessiAPI["update:database"]
                    ? <textarea
                        type="text"
                        rows="25"
                        id="note"
                        name={'note'}
                        value={elementoTemp.note ?? ""}
                        onChange={handleChange}
                        className={inputClassesNOW + " w-100"} />
                    : <p>{elementoTemp.note ?? ""}</p>
                }
                <div>ID {elementoTemp.id}</div>
            </div>
        )
    }

    function riquadroIndirizzoResi() {
        return (
            <div></div>
        )
    }

    function riquadroCorrieri(height) {
        return (<div className={"h-" + height + "-ns sezioneConScroll"}>
        <h3 className="tc">Corrieri</h3>
            <div className="pa4  items-center flex flex-wrap justify-between">
            <InputDatoTendinaGenerico
                        inputLabel="Tipo"
                        datoName='Tipo'
                        elencoDati={datiTendineOrdine.tipoOrdine}
                        datoId="tipo"
                        datoValue={elementoTemp?.["Tipo"] ?? ''}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoTendinaGenerico
                        inputLabel="Causale"
                        datoName='Causale'
                        elencoDati={datiTendineOrdine.causaleSped}
                        datoId="causale"
                        datoValue={elementoTemp?.["Causale"] ?? ''}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                <InputDatoProdotto
                    inputLabel="Spese sped"
                    datoName='Spese_di_spedizione'
                    tipoInput="number"
                    datoId="Spese_di_spedizione"
                    datoValue={elementoTemp?.["Spese_di_spedizione"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-45"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <InputDatoProdotto
                    inputLabel="Costo sped"
                    datoName='Costo_spedizione'
                    tipoInput="number"
                    datoId="Costo_spedizione"
                    datoValue={elementoTemp?.["Costo_spedizione"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-45"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <InputDatoTendinaGenerico
                    inputLabel="Porto franco"
                    datoName='Porto'
                    elencoDati={datiTendineOrdine.portoFranco}
                    datoId="Porto"
                    datoValue={elementoTemp?.["Porto"] ?? ''}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <InputDatoProdotto
                    inputLabel="Spese c/ass"
                    datoName='Spese_di_contrassegno'
                    datoId="Spese_di_contrassegno"
                    tipoInput="number"
                    datoValue={elementoTemp?.["Spese_di_contrassegno"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-45"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <InputDatoProdotto
                    inputLabel="Tot imp. c/ass"
                    datoName='Tot_imp_contrassegno'
                    tipoInput="number"
                    datoId="Tot_imp_contrassegno"
                    datoValue={elementoTemp?.["Tot_imp_contrassegno"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-45"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <InputDatoProdotto
                    inputLabel="Colli"
                    datoName='N_Colli'
                    tipoInput="number"
                    datoId="N_Colli"
                    datoValue={elementoTemp?.["N_Colli"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-45"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <InputDatoProdotto
                    inputLabel="Peso in kg"
                    datoName='Peso'
                    tipoInput="number"
                    datoId="Peso"
                    datoValue={elementoTemp?.["Peso"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-45"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <div className="w-100 mb2">Dimensioni collo/i</div>
                <InputDatoProdotto
                    inputLabel="L"
                    datoName='Dim_Collo_L'
                    tipoInput="number"
                    datoId="Dim_Collo_L"
                    datoValue={elementoTemp?.["Dim_Collo_L"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-30"}
                    labelClass={"wpx-30"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <InputDatoProdotto
                    inputLabel="A"
                    datoName='Dim_Collo_H'
                    tipoInput="number"
                    datoId="Dim_Collo_H"
                    datoValue={elementoTemp?.["Dim_Collo_H"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-30"}
                    labelClass={"wpx-30"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <InputDatoProdotto
                    inputLabel="P"
                    datoName='Dim_Collo_P'
                    tipoInput="number"
                    datoId="Dim_Collo_P"
                    datoValue={elementoTemp?.["Dim_Collo_P"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-30"}
                    labelClass={"wpx-30"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <InputDatoProdotto
                    inputLabel="Sede fermo deposito"
                    datoName='Fermo_deposito'
                    datoId="Fermo_deposito"
                    datoValue={elementoTemp?.["Fermo_deposito"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-70"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <InputDatoTendinaGenerico
                    inputLabel="Corriere"
                    datoName='Corriere'
                    elencoDati={datiTendineOrdine.corriere}
                    datoId="Corriere"
                    datoValue={elementoTemp?.["Corriere"] ?? ''}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <InputDatoProdotto
                    inputLabel="Tracking"
                    datoName='N_Trakking'
                    datoId="N_Trakking"
                    datoValue={elementoTemp?.["N_Trakking"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                />
                <label for="noteCorr" className="w-100">Note corriere</label>
                {utente.permessiAPI["update:database"]
                    ? <textarea
                        type="text"
                        rows="3"
                        id="noteCorr"
                        name='Note_Corriere'
                        value={elementoTemp?.["Note_Corriere"] ?? ""}
                        onChange={handleChange}
                        className={inputClassesNOW + " w-100"} />
                    : <p>{elementoTemp?.["Note_Corriere"] ?? ""}</p>
                }

                {(elementoTemp?.["Corriere"] === "BRT" || elementoTemp?.["Corriere"] === "DPD") && <div className="flex flex-wrap justify-between items-center riqBRT">
                    <div className="w-100 fw5 b mt3 mb1">BRT/DPD</div>
                    <InputDatoTendinaGenerico
                        inputLabel="Network"
                        datoName='Network'
                        elencoDati={datiTendineOrdine.brtNetwork}
                        datoId="brtNetwork"
                        datoValue={elementoTemp?.["Network"] ?? ''}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-45"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="Cod tariffa"
                        datoName='Cod_tariffa'
                        datoId="brtCod_tariffa"
                        datoValue={elementoTemp?.["Cod_tariffa"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-45"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoTendinaGenerico
                        inputLabel="Tipo servizio"
                        datoName='Tipo_servizio'
                        elencoDati={datiTendineOrdine.brtServizio}
                        datoId="brtServizio"
                        datoValue={elementoTemp?.["Tipo_servizio"] ?? ''}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-45"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="Codice PUDO"
                        datoName='codicePUDO'
                        datoId="codicePUDO"
                        datoValue={elementoTemp?.["codicePUDO"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-45"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                </div>}
                {elementoTemp?.["Corriere"] === "DHL" && <div className="flex flex-wrap justify-between items-center riqDHL">
                    <div className="w-100 fw5 b mt3 mb1">DHL</div>
                    <InputDatoTendinaGenerico
                        inputLabel="Tipo"
                        datoName='DHL_Tipo_Sped'
                        elencoDati={datiTendineOrdine.dhlTipo}
                        datoId="dhlTipo"
                        datoValue={elementoTemp?.["DHL_Tipo_Sped"] ?? ''}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-45"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoTendinaGenerico
                        inputLabel="Dog"
                        datoName='DHL_Dogana'
                        elencoDati={datiTendineOrdine.dhlDog}
                        datoId="dhlDog"
                        datoValue={elementoTemp?.["DHL_Dogana"] ?? ''}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-45"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <div className="w-100 items-center flex justify-between mb2">
                        <InputTendinaDatoProdotto
                            inputLabel="Cod paese"
                            datoName='DHL_Cod_Paese'
                            datoId="DHL_Cod_Paese"
                            datoOnChange={handleChange}
                            datoClass={inputClassesNOW + " w-80 h-100"}
                            objOpzioni={datiTendineOrdine.dhlCodPaese}
                            datoValue={elementoTemp?.["DHL_Cod_Paese"] ?? ''}
                            bloccoClass={"w-50"}
                            permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                            labelOrizzontale="SI"
                        />
                        <div className="w-40 b">{elementoTemp?.["DHL_Cod_Paese"] ?? ''}</div>
                    </div>
                    <InputDatoProdotto
                        inputLabel="Contenuto"
                        datoName='DHL_Descr_cont'
                        datoId="DHL_Descr_cont"
                        datoValue={elementoTemp?.["DHL_Descr_cont"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                </div>}
                {elementoTemp?.["Corriere"] === "UPS" && <div className="flex flex-wrap justify-between items-center riqUPS">
                    <div className="w-100 fw5 b mt3 mb1">UPS</div>
                    <InputDatoProdotto
                        inputLabel="Tipo servizio"
                        datoName='UPS_Servizio'
                        datoId="upsServizio"
                        datoValue={elementoTemp?.["UPS_Servizio"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-45"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                </div>}

            </div>
        </div>
        )
    }

    function associaAContatto() {
        if (elementoTemp.id) {
            return (
                <ListaAssocia
                    idElemento1={elementoTemp.id}
                    colonnaID1={"id2"}
                    colonnaID2={"id1"}
                    tipoCong={"CF"}
                    tabellaElemento2={"DAM_Contatti"}
                    riquadroElemento2={listaRiquadriContatti}
                    height={100}
                    titolo={"Contatti collegati"}
                    token={token}
                    querySpecifica={false}
                    utente={utente}
                />
            )
        } else {
            return (
                <p>Devi salvare il fornitore prima di associare i contatti</p>
            )
        }

    }

    function associaABrand() {
        if (elementoTemp.id) {
            return (
                <ListaAssocia
                    idElemento1={elementoTemp.id}
                    colonnaID1={"id2"}
                    colonnaID2={"id1"}
                    tipoCong={"BF"}
                    tabellaElemento2={"DAM_Brands"}
                    riquadroElemento2={listaRiquadriBrands}
                    height={100}
                    titolo={"Brands collegati"}
                    token={token}
                    querySpecifica={false}
                    utente={utente}
                />
            )
        } else {
            return (<p>Devi salvare il fornitore prima di associare i brand</p>)
        }

    }

    function riquadroDatiSpedizioneCliente(height) {
        return (<div className={"h-" + height + "-ns sezioneConScroll"}>
            <div className="colonna85vh sezioneConScroll">
                <div className="flex flex-wrap justify-between">
                    <h3>Dati spedizione cliente</h3>
                    <InputDatoProdotto
                        inputLabel="Cliente PS"
                        datoName='nomeCliente'
                        datoId="nomeCliente"
                        datoValue={elementoTemp?.["nomeCliente"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={"NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="Nome sped"
                        datoName='NomeCognome'
                        datoId="NomeCognome"
                        datoValue={elementoTemp?.["NomeCognome"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="P.IVA / C.F."
                        datoName='PIva CF'
                        datoId="pIVA"
                        datoValue={elementoTemp?.["PIva CF"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="Società"
                        datoName='Società'
                        datoId="society"
                        datoValue={elementoTemp?.["Società"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="Indirizzo 1"
                        datoName='Indirizzo'
                        datoId="ind1"
                        datoValue={elementoTemp?.["Indirizzo"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="Indirizzo 2"
                        datoName='Indirizzo_2'
                        datoId="ind2"
                        datoValue={elementoTemp?.["Indirizzo_2"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="C/O"
                        datoName='C/O'
                        datoId="careof"
                        datoValue={elementoTemp?.["C/O"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="CAP"
                        datoName='CAP'
                        datoId="cap"
                        datoValue={elementoTemp?.["CAP"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-60 h-100"}
                        datoClass={"w-60"}
                        labelClass={"w-30"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="Prov"
                        datoName='Provincia'
                        datoId="provincia"
                        datoValue={elementoTemp?.["Provincia"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-70 h-100"}
                        datoClass={"w-30"}
                        labelClass={"w-30"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="Città"
                        datoName='Città'
                        datoId="city"
                        datoValue={elementoTemp?.["Città"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputTendinaDatoProdotto
                        inputLabel="Nazione"
                        datoName='Paese di provenienza'
                        datoId="nazione"
                        datoOnChange={handleChange}
                        datoClass={inputClassesNOW + " w-80 h-80"}
                        objOpzioni={datiTendineOrdine.nomiNazioni}
                        datoValue={elementoTemp?.["Paese di provenienza"] ?? ''}
                        bloccoClass={"w-100"}
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                        labelOrizzontale="SI"
                    />
                    <div className="w-100 items-center flex justify-between mb1">
                        <InputTendinaDatoProdotto
                            inputLabel="cod Nazione"
                            datoName='Cod_Paese'
                            datoId="Cod_Paese"
                            datoOnChange={handleChange}
                            datoClass={inputClassesNOW + " w-80 h-100"}
                            objOpzioni={datiTendineOrdine.codiceNazioni}
                            datoValue={elementoTemp?.["Cod_Paese"] ?? ''}
                            bloccoClass={"w-70"}
                            permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                            labelOrizzontale="SI"
                        />
                        <div className="w-20 b">{elementoTemp?.["Cod_Paese"] ?? ''}</div>
                    </div>
                    <div className="w-100 items-center flex justify-between mb1">
                        <InputTendinaDatoProdotto
                            inputLabel="Prefisso"
                            datoName='TEL_Prefix'
                            datoId="TEL_Prefix"
                            datoOnChange={handleChange}
                            datoClass={inputClassesNOW + " w-80 h-80"}
                            objOpzioni={datiTendineOrdine.prefissoNazione}
                            datoValue={elementoTemp?.["TEL_Prefix"] ?? ''}
                            bloccoClass={"w-70"}
                            permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                            labelOrizzontale="SI"
                        />
                        <div className="w-20 b">{elementoTemp?.["TEL_Prefix"] ?? ''}</div>
                    </div>
                    <InputDatoProdotto
                        inputLabel="Tel Cell"
                        datoName='Telefono cell'
                        datoId="telCell"
                        datoValue={elementoTemp?.["Telefono cell"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="Tel Fisso"
                        datoName='Telefono fisso'
                        datoId="telFisso"
                        datoValue={elementoTemp?.["Telefono fisso"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="eMail"
                        datoName='E-mail'
                        datoId="eMail"
                        datoValue={(elementoTemp?.["E-mail"] && elementoTemp?.["E-mail"].includes("#")) ? togliMailto(elementoTemp["E-mail"]) : elementoTemp?.["E-mail"] && elementoTemp["E-mail"]}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80 h-100"}
                        datoClass={"w-90"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    {elementoTemp?.["E-mail"] && <a className="linkMail material-icons mb2" href={"mailto:" + togliMailto(elementoTemp["E-mail"])}>mail</a>}


                </div>
            </div>
        </div>)
    }

    function istruzioniWarranties() {
        return (
            <div>
                <h3>Istruzioni per warranties e resi a fornitore</h3>
                {/* <label for="istruzioniReso" className="w-100 mt3">Istruzioni warranties</label> */}
                {utente.permessiAPI["update:database"]
                    ? <textarea
                        type="text"
                        rows="25"
                        id="istruzioniReso"
                        name={'istruzioniReso'}
                        value={elementoTemp.istruzioniReso ?? ""}
                        onChange={handleChange}
                        className={inputClassesNOW + " w-100"} />
                    : <p>{elementoTemp.istruzioniReso ?? ""}</p>
                }
            </div>
        )
    }

    function datiB2B() {
        return (
            <div>
                <h3>Dati B2B e DAM</h3>
                {/* <label for="istruzioniReso" className="w-100 mt3">Istruzioni warranties</label> */}
                {utente.permessiAPI["update:database"]
                    ? <textarea
                        type="text"
                        rows="20"
                        id="datiB2B"
                        name={'datiB2B'}
                        value={elementoTemp.datiB2B ?? ""}
                        onChange={handleChange}
                        className={inputClassesNOW + " w-100"} />
                    : <p>{elementoTemp.datiB2B ?? ""}</p>
                }
            </div>
        )
    }

    function riquadroSceltaTab(height) {
        return (
            <div className="flex flex-wrap">
                <TastoSelezionaTab
                    idTasto="indirizzoReso"
                    onClickTasto={cambiaTab}
                    tab={tab}
                    vociMenuTabsSelezionata={vociMenuTabsSelezionata}
                    vociMenuTabs={vociMenuTabs}
                    icona="local_shipping"
                    testo="Indirizzo reso"
                />
                <TastoSelezionaTab
                    idTasto="brandEcontatti"
                    onClickTasto={cambiaTab}
                    tab={tab}
                    vociMenuTabsSelezionata={vociMenuTabsSelezionata}
                    vociMenuTabs={vociMenuTabs}
                    icona="contacts"
                    testo="Brand e Contatti"
                />
                <div className="mt3 dn db-ns ">
                    {utente.permessiAPI["read:debug"] && <h3 className={vociMenuTabs + "mt4 pt3 mb3 bt bordoColAlt"}>debug</h3>}
                    {utente.permessiAPI["read:debug"] && <div id="ordineObj" onClick={cambiaTab} className={tab === "ordineObj" ? vociMenuTabsSelezionata : vociMenuTabs}>Oggetto Fornitore</div>}
                    {utente.permessiAPI["read:debug"] && <div id="ordineObjUtente" onClick={cambiaTab} className={tab === "ordineObjUtente" ? vociMenuTabsSelezionata : vociMenuTabs}>Oggetto utente</div>}
                    {utente.permessiAPI["read:debug"] && <div id="resImport" onClick={cambiaTab} className={tab === "resImport" ? vociMenuTabsSelezionata : vociMenuTabs}>Feedback salvataggio</div>}

                </div>
            </div>)
    }
    function riquadroObj(height) {
        return (<div className={"h-" + height + "-ns sezioneConScroll"}>
            <pre>{JSON.stringify(elementoTemp, null, 2)}</pre>
            {/* <pre>{JSON.stringify(elementoTemp, null, 2)}</pre> */}
        </div>)
    }

    function riquadroObjUtente(height) {
        return (<div className={"h-" + height + "-ns sezioneConScroll"}>
            <pre>{JSON.stringify(utente, null, 2)}</pre>
            {/* <pre>{JSON.stringify(elementoTemp, null, 2)}</pre> */}
        </div>)
    }

    function riquadroFeedback(height) {
        return (<div className={"h-" + height + "-ns sezioneConScroll"}>
            <pre>{JSON.stringify(resultSalvataggio, null, 2)}</pre>
        </div>)
    }

    //////////////////////////////////////////////////////////////////////////////////

    function colonnaServizio(widthCol1, tab1, hTab1, tab2, hTab2, widthCol2, col2tab1, hCol2Tab1, col2tab2, hCol2Tab2) {
        return (
            <div className="w-100 w-80-ns w-50-l flex flex-wrap h-100">
                <div className={"w-100 w-" + widthCol1 + "-l pa3 bl-ns bordoColAlt h-100"}>
                    <div className=" h-100">
                        {tab1 && tab1(hTab1)}
                        {tab2 && <div className="h-50 bt bordoColAlt dn db-ns">{tab2(hTab2)}</div>}
                    </div>
                </div>
                <div className={"w-100 w-" + widthCol2 + "-l pa3 bl-ns dn db-ns bordoColAlt h-100"}>
                    <div className=" h-100 ">
                        {col2tab1 && col2tab1(hCol2Tab1)}
                        {col2tab2 && <div className="h-50 bt bordoColAlt">{col2tab2(hCol2Tab2)}</div>}
                    </div>
                </div>
            </div>)

    }

    ///// PAGINA

    return (

        <div className={classDivPrincipale}>
            <div className="w-100 ma3-ns br4-ns sfondoBiancoTema flex flex-wrap h-100 h-97-ns">
                <div className="w-100 flex flex-wrap justify-center h-100">
                    <div className="w-50 flex flex-wrap">
                        <div className="w-40 dn db-ns pa2-ns pl4-ns pt4-ns pb4-ns datiOrdine">
                            <div className="colonna85vh sezioneConScroll">
                                {riquadroSalvataggio()}
                                {riquadroDatiFornitore()}
                            </div>
                        </div>
                        <div className="w-40 dn db-ns pa2-ns pl4-ns pt4-ns pb4-ns statoENote bl-ns bordoColAlt">
                            <div className="colonna85vh pr3">
                                {istruzioniWarranties()}
                                {datiB2B()}
                            </div>
                        </div>
                        <div className="w-20 pl4-ns pt4-ns pb4-ns bl-ns bordoColAlt relative flex justify-center db-ns">
                            {riquadroSceltaTab()}
                        </div>
                    </div>
                    {tab === "brandEcontatti" && colonnaServizio(50, associaABrand, 100, false, false, 50, associaAContatto, 100, false, false)}
                    {tab === "indirizzoReso" && colonnaServizio(50, riquadroCorrieri, 100, false, false, 50, riquadroDatiSpedizioneCliente, 100, false, false)}
                    {tab === "ordineObj" && colonnaServizio(60, riquadroObj, 100, false, false, 40, riquadroObjUtente, 100, false, false)}
                    {tab === "ordineObjUtente" && colonnaServizio(60, riquadroObjUtente, 100, false, false, 40, riquadroObj, 100, false, false)}
                    {tab === "resImport" && colonnaServizio(60, riquadroFeedback, 100, false, false, 40, riquadroObj, 100, false, false)}
                </div>
            </div>
        </div>

    )
}

export default withLogisticaConfiguration(ModificaFornitori);



